export const dictionary:any = {
	"en":{
		"continue": "Continue",
		"resume":"Resume",
		"start":"Start",
		"back":"Back",
		"hide":"Hide",
		"show":"Show",
		"rerun": "Re-Run",
		"testHasCompleted": "Test has completed",
		"sessionEnded": "Procedure has finished",
		"participationThanks":"Thank you for participating",
		"virtualReality":"Virtual Reality",
		"finish":"Finish",
		"answersSavedToDatabase":"Answers have been saved in database",
		"form_atLeastOneOption": "Please select at least one option",
		"form_selectOption": "Please select an option",
		"form_enterValue": "Please enter a value",
		"form_fillOptions": "Please fill out options",
		"form_formIsInvalid": "To continue, please fill out required information above",
		"proxy_linkIsClosed": "This link has been closed",
		"study_participateInStudy": "Open Survey",
		"study_sessionInProgress": "Session in progress",
		"session_deviceSetup":"Device Setup",
		"session_pleaseEnableMotion":"Please continue to enable motion controls on your device.",
		"fb_warningTitle":"...hang on!",
		"fb_notify":`You appear to be visiting through <span class="font-weight-bold">facebook</span>.`,
		"fb_explain":`For our site to work correctly please switch to a normal browser window.`,
	},
	"is":{
		"continue": "Áfram",
		"resume":"Halda Áfram",
		"start":"Byrja",
		"back":"Til Baka",
		"hide":"Fela",
		"show":"Sýna",
		"rerun": "Endurkeyra",
		"testHasCompleted": "Prófi hefur lokið",
		"sessionEnded": "Keyrslu er lokið",
		"participationThanks":"Takk fyrir þátttökuna",
		"virtualReality":"Sýndarveruleiki",
		"finish":"Ljúka",
		"answersSavedToDatabase":"Svör við 	spurningum hafa verið vistuð í gagnagrunni",
		"form_atLeastOneOption": "Vinsamlegast veldu að minnsta kosti einn valkost",
		"form_selectOption": "Vinsamlegast veldu valkost",
		"form_enterValue": "Vinsamlegast fylltu inn gildi",
		"form_fillOptions": "Vinsamlegast fylltu inn valkosti",
		"form_formIsInvalid": "Til að halda áfram, vinsamlegast fyllið inn upplýsingar sem vantar hér að ofan",
		"proxy_linkIsClosed": "Þessum tengli hefur verið lokað",
		"study_participateInStudy": "Opna könnun",
		"study_sessionInProgress": "Keyrsla í gangi",
		"session_deviceSetup":"Uppsetning snjalltækis",
		"session_pleaseEnableMotion":"Vinsamlegast haltu áfram til að virkja hreyfivirkni.",
		"fb_warningTitle":"...bíddu aðeins!",
		"fb_notify":`Þú virðist vera að heimsækja gegnum <span class="font-weight-bold">facebook</span>.`,
		"fb_explain":`Til að síðan okkar virki rétt vinsamlegast skiptu yfir í venjulegan vafraglugga.`,
	}
};